import React, { PropsWithChildren, useEffect, useState } from 'react';
import { getAuthTokens } from 'utils/cookies';
import { apiApp } from 'utils/service';

export const AxiosInterceptorsToken: React.FC<PropsWithChildren> = ({ children }) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    const ids = [apiApp].map((instance) => {
      const id = instance.interceptors.request.use((config) => {
        const { token } = getAuthTokens();
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: 'Bearer ' + token,
          };
        }
        return config;
      });
      return { id, instance };
    });

    setInit(true);
    return () => {
      ids.forEach(({ instance, id }) => {
        instance.interceptors.request.eject(id);
      });
    };
  }, []);

  return <>{init && children}</>;
};
